module.exports = __webpack_public_path__ + "static/media/title_sliding.808757cb.jpg";